import { render, staticRenderFns } from "./InventoryStatusButton.vue?vue&type=template&id=2b4fa9aa&scoped=true&"
import script from "./InventoryStatusButton.vue?vue&type=script&lang=js&"
export * from "./InventoryStatusButton.vue?vue&type=script&lang=js&"
import style0 from "./InventoryStatusButton.vue?vue&type=style&index=0&id=2b4fa9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4fa9aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b4fa9aa')) {
      api.createRecord('2b4fa9aa', component.options)
    } else {
      api.reload('2b4fa9aa', component.options)
    }
    module.hot.accept("./InventoryStatusButton.vue?vue&type=template&id=2b4fa9aa&scoped=true&", function () {
      api.rerender('2b4fa9aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Inventory/buttons/InventoryStatusButton.vue"
export default component.exports